/**
 * Thin wrapper around full-page browser navigation so it can be spied on in
 * tests. Used for OAuth/authorize navigation and post-success redirects
 * (spec §14.2). Never used with unvalidated URLs.
 */
export const browserNavigation = {
  /** User-initiated navigation (login/link start). */
  assign(url: string): void {
    window.location.assign(url);
  },
  /** Post-success redirect (auth complete -> product/account). */
  replace(url: string): void {
    window.location.replace(url);
  },
};
